
import { Component, Inject, OnDestroy, OnInit ,HostListener, Output, EventEmitter} from '@angular/core';
import { Store } from '@src/store';
import { DialogManagerService } from '@src/services';
import { DbTypeService } from '@src/services/dbTypeService';
import { consts } from '@src/constants/consts';
import { projectActions } from "../../../../store/reducers/projectReducer";
import { cmsActions } from "../../../../store/reducers/cmsReducer";
import { userActions } from "../../../../store/reducers/userReducer";
import * as lodash from "lodash";

@Component({
    selector: 'settings',
    template: require('./settings.html'),
    styles: [require('./_settings.scss')]
})

export class SettingComponent implements OnInit , OnDestroy {

       @Output() public projectdata = new EventEmitter<any>();

        public projectDataDefaults = null;
        public projectData:any
        public objectsArray:any
        public isLockMainPath = false;
        public _selectedProjectGroup = null;
        public placeHolderProjectGroup :any;
        public _selectedDatabaseType = null;
        public placeHolderDBType = "--Please choose DB Type--";
        public databaseType = null;
        public dbTypeFlags = null;
        public AutoGenerateDryRun:boolean = true;
        public $translate:any
        public canEditPackageScripts:boolean
        public CMSitem:any;
        public unSubscribe:any
        public SkipPostValidation:boolean
        public SkipPreValidation:boolean
        public cmss:any
        public SourceControlPathType:any;
        public RequireDowngradeScripts:boolean;
        public unSubscribeForCMSproject:any
        public cmsProjects:any
        public BreakOnDowngradeFailed:boolean;
        public unSubscribeDbAndPathType:any
        public pathTypeOptions:any
        public SaveEncodingCodePage:number = 1255
        public projectGroups:any
        public selectedConflictActions:any
        public selectedDuplicationAction:any
        public UseDowngradeScripts:boolean
        public dropUp:any
        public CMS:boolean;
        public isSuperUser:boolean;
        public selectedCMSitem:any = "None"
        public selectedProjectCMSitem:any
        public mainPath:any
        public isAdditionalOptionsCollapsed:boolean
        public selectedProjectCMSite:any
        public selectedProjectCMS:any
        public selectedCMSid:any
        public isAutoImportScripts:boolean;
        public name:string
        public autoPackageIntervalInMinutes:any
        public autoImportScriptsIntervalInMinutes:any;
        public isAutoPackage:boolean
        public DeployModeTypes:string[] = []
        public selectedProjectType:any = "DB2"
        public description:string
        public getIn:boolean = true
        public isCollapsed:boolean = true;
        public SourceControlFolder:string;


    constructor(private store: Store,@Inject('$scope') public $scope: any, @Inject('$state') public state: any,@Inject('$stateParams') public $stateParams: any,
                private dialogManagerService: DialogManagerService, @Inject('$filter') private $filter: any, @Inject('authorizationService') private authorizationService: any 
                , @Inject('dbTypeService') private dbTypeService: DbTypeService) {
                    this.placeHolderProjectGroup = !this.projectData ? "--Please choose Project Group--" : null;
                    this.$translate = this.$filter('translate');
    }

    // this.onChangeHost.emit({ hostselected: this.selectedHost,
    //     unmangeSchemasByHostList: this.unmangeSchemasByHostList })

    ngOnInit() {
        this.showDropUp();
        this.authorizationService.isAuthorizedToPerformAction(consts.userPermissions.UpdateScript).then(canEditPackageScripts => {
            setTimeout(() => { this.canEditPackageScripts = canEditPackageScripts; }, 50);
        });
        this.store.dispatch({ type: projectActions.GET_PROJECT_ENUMS });
    //   if(this.getIn){
    //     for (let x in this.store.getState().enums.DeployModeTypes) {
    //         this.DeployModeTypes.push(this.setLabel(this.store.getState().enums.DeployModeTypes[x]))
    //      }
    //      this.getIn = false
    //   }
        // this.DeployModeTypes = this.store.getState().enums.DeployModeTypes.map((x,index) => {this.setLabel(x[index])});
        
        if (this.store.getState().project && this.store.getState().project.schemas) {
            delete this.store.getState().project.schemas;
        }
        this.unSubscribe = this.store.subscribe(() => {
            if (this.store.getState().cmss && this.store.getState().cmss.cmss && this.store.getState().cmss.cmss.length > 0) {
                this.cmss = this.store.getState().cmss.cmss;
                this.unSubscribe();
            }
        });

        this.unSubscribeForCMSproject = this.store.subscribe(() => {
            if (this.store.getState().cmss && this.store.getState().cmss.projects && this.store.getState().cmss.projects.length > 0) {
                this.cmsProjects = this.store.getState().cmss.projects;
            }
        });
        this.unSubscribeDbAndPathType = this.store.subscribe(() => {
            if (this.store.getState().enums && this.store.getState().enums.DBTypes) {
                this.databaseType = lodash.orderBy(this.store.getState().enums.DBTypes, ['value'], ['asc']);
            }
            if (this.store.getState().enums && this.store.getState().enums.SourceControlPathTypes) {
                const { SourceControlPathTypes } = this.store.getState().enums;
                this.pathTypeOptions = SourceControlPathTypes;
                this.SourceControlPathType = this.pathTypeOptions[0]
            }
            if(this.store.getState().enums.DBTypes &&  this.store.getState().enums.SourceControlPathTypes) {
                this.unSubscribeDbAndPathType();
            }
        });

        if (this.state.params.remember == 'edit' && !this.projectData) {
            this.state.go('app.authorized.projectWizard.settings', { id: this.state.params.id, step: 1, remember: 'new' });
        }

        this.$scope.$watch(() => this.projectData, () => {
            if (this.projectData) {
                for (let x in this.store.getState().enums.DeployModeTypes) {
                    this.DeployModeTypes.push(this.setLabel(this.store.getState().enums.DeployModeTypes[x]))
                 }
                this.selectedProjectType = this.DeployModeTypes[0]
                this.insertToJson('dplModeType',this.selectedProjectType)
                this.updatePath();
                if (!this.projectDataDefaults)
                    this.projectDataDefaults = lodash.cloneDeep(this.projectData);
                this.SaveEncodingCodePage = this.projectData.options.DeployOptions['SaveEncoding'];
            } else {
                this._selectedDatabaseType = null;
                this._selectedProjectGroup = null;
                this.store.dispatch({ type: projectActions.GET_NEW_PROJECT, payload: { projectType: 1 } }).then(x => {
                this.projectData = x.data;
                this.projectData.options.DeployOptions.SourceControlPathType = "0"; 
                }).then(x => {
                    if(x){}
                    this.store.dispatch({ type: cmsActions.GET_ALL_CMS });
                    this.store.dispatch({ type: userActions.GET_USER_PROJECT_GROUPS }).then(res => {
                        this.projectGroups = res.data;
                        if (this.projectGroups) {
                            if (this.projectGroups.length == 1) {
                                setTimeout(() => { this.selectedProjectGroup = this.projectGroups[0]; }, 50, true);
                            } 
                            else {
                                if (this.projectData && this.projectData.projectGroupId) {
                                    this.selectedProjectGroup = this.projectGroups.find(item => item.id == this.projectData.projectGroupId);
                                }
                            }
                        }
                    });
                });
            }
        });

        if (this.projectData && this.projectData.dbTypeId) {
            this._selectedDatabaseType = this.store.getState().enums.DBTypes.find(item => item.key == this.projectData.dbTypeId);
            this.loadDBTypeSpecific(this._selectedDatabaseType.key);
            this.insertToJson('databaseType',this._selectedDatabaseType)
        }
        if (this.projectData && this.projectData.options.CMS && this.projectData.connectedCmsProject) {
            this.setCMSToProject(true);
        }
        if (this.projectData && this.projectData.options.ConflictAction && !this.selectedConflictActions) {
            this.selectedConflictActions = this.store.getState().enums.ConflictResloveActionTypes[this.projectData.options.ConflictAction];
        }
        if (this.projectData && this.projectData.options.DuplicationAction && !this.selectedDuplicationAction) {
            this.selectedDuplicationAction = this.store.getState().enums.DuplicationActionTypes[this.projectData.options.DuplicationAction];
        }
    }

    ngOnDestroy(): void {
        this.unSubscribeForCMSproject();   
    }

    public insertToJson(fieldName:string,value,fieldName2 = null,fieldName3 = null){
        if(fieldName2 != null || fieldName3 != null){
            if(fieldName3 != null && this.projectData[fieldName][fieldName2][fieldName3] != undefined){ 
                 if(this.projectData[fieldName][fieldName2] == undefined){
                    this.projectData[fieldName][fieldName2] = {};
                 }
                this.projectData[fieldName][fieldName2][fieldName3] = value
            }
           else {
                this.projectData[fieldName][fieldName2] = value

           }
        }
        else {
            this.projectData[fieldName] = value
        }
        this.projectdata.emit({ fieldName: fieldName , value :value , fieldName2:fieldName2 ,fieldName3:fieldName3 })
     }
    restoreDefaults() {
        const additionalOption = lodash.cloneDeep(this.projectData.additionalOption);
        this.projectData = lodash.cloneDeep(this.projectDataDefaults);
        this.insertToJson('additionalOption',additionalOption)
    }

    resetEnvTypes() {
        if (!this.projectData.isTest){
            this.insertToJson('environmentTypes',this.projectData.environmentTypes.filter(envType => !envType.isTest))
        }        
    }

    scrollToEnd = () => {
       
            setTimeout(() => {
                const dbTypeList = document.getElementById("dbTypesList");
                const uiViews = document.getElementsByTagName("ui-view");
                const wizardFooter = document.getElementsByClassName("wizard-footer");
                const lackingScrollHeight = dbTypeList.getBoundingClientRect().bottom - wizardFooter[0].getBoundingClientRect().top;
                if (lackingScrollHeight > 0) {
                    uiViews[1].scrollTop += lackingScrollHeight;
                }
            }, 50, true);
        
    };

    showDropUp() {
        if (document) {
            // setTimeout(() => { this.dropUp = document[0].documentElement.clientWidth < 992; }, 50, true);
        }
    }

    public changeAutoGenrete(flag:boolean){
        if(this.dbTypeFlags?.AutoGenerateSchema == true){
            this.insertToJson('options',flag,'AutoGenerateDryRun')
        }
    }

    setSelectedDatabaseType(value) {
        const formattedValue = { key: value.key, value: value.value };
        // this._selectedDatabaseType = formattedValue;
        if (!this.projectData) {
            this.projectData = {};
        }
        this.insertToJson('databaseType',formattedValue)
        if (this.projectData.dbTypeId != this.projectData.databaseType.key) {
            this.insertToJson('connectedCmsProject',{})
            this.insertToJson('isSuperUser',false)
            this.insertToJson('isTest',false)
            if(this.projectData.options === undefined){
                this.insertToJson('options',{})
            }
            this.insertToJson('options',false,'CMS')
            this.insertToJson('options',false,'BreakOnDowngradeFailed')
            this.insertToJson('options',false,'RequireDowngradeScripts')
        }
        (this.projectData.databaseType) ? this.insertToJson('dbTypeId',this.projectData.databaseType.key) : this.insertToJson('dbTypeId',null);
        this.insertToJson('environmentTypes',[])
        this.insertToJson('dataFlowType',null)
        this.insertToJson('userInitiatedChange',true)
        this.store.dispatch({ type: projectActions.RESET_ENV_TYPES });
    }


    // update the Scripts Source with the project Name that is written
    updatePath() {
        if (this.projectData) {
            // if (this.mainPath) {
            //     const projectName = this.projectData.name ? "\\" + this.projectData.name : '';
            //     if (this.projectData != null &&
            //         this.projectData.parentId == null /* &&
            //         (this.projectData.options['ScriptOutputFolder'] == null ||
            //             this.projectData.options['ScriptOutputFolder'] == '')*/) {
            //         //this.projectData.options['ScriptOutputFolder'] = this.mainPath + projectName;
            //     } else if (!this.projectData.name)
            //         /*this.projectData.options['ScriptOutputFolder'] = this.mainPath*/;
            //     else if (this.projectData && this.projectData.name) {
            //         /*this.projectData.options['ScriptOutputFolder'] = this.mainPath + projectName*/;
            //     }
            // }

            if (this.projectData.connectedCmsProject && this.selectedCMSitem) //for bug 12879
                this.getProjectCMS();
        }
    }

    set selectedSCPathType(value) {
        this.insertToJson('options',value,'DeployOptions','SourceControlPathType')
    }

    get selectedSCPathType() {
        return this.projectData.options.DeployOptions.SourceControlPathType;
    }

    set selectedProjectGroup(value) {
        this._selectedProjectGroup = value;
        if (!this.projectData) {
            this.projectData = {};
        }
        this.insertToJson('projectGroupId',value.id)
        this.mainPath = value.projectGroupDefaultPath;
        this.updatePath();
    }

    get selectedProjectGroup() {
        return this._selectedProjectGroup;
    }



    get selectedDatabaseType() {
        return (this.projectData && this.projectData.databaseType) ? this.projectData.databaseType : this.placeHolderDBType
    }

    set selectedVersionControl(value) {
        this.insertToJson('options',value,'FileVersionControlType')
    }

    get selectedVersionControl() {
        return this.projectData && this.projectData.options && this.store.getState().enums.FileVersionControlTypes
            ? this.store.getState().enums.FileVersionControlTypes[this.projectData.options.FileVersionControlType]
            : null;
    }

    set selectedContinuesIntegrationType(value) {

        this.insertToJson('options',value,'ContinuousIntegrationType')
    }

    get selectedContinuesIntegrationType() {
        return this.projectData && this.projectData.options && this.store.getState().enums.ContinuousIntegrationTypes
            ? this.store.getState().enums.ContinuousIntegrationTypes[this.projectData.options.ContinuousIntegrationType]
            : null;
    }

    setLabel(title) {
        switch (title) {
            case "ByVersion":
                return "Deploy by Versions";
            case "ByTask":
                return "Deploy by Task";
        }
    }


    getProjectCMS() {
        this.insertToJson('connectedCmsProject',{})
         this.selectedCMSitem = this.store.getState()?.cmss?.cmss.find(x => x.name == this.CMSitem)
        if (this.selectedCMSitem && this.selectedCMSitem.type != 6) {
            this.selectedProjectCMSitem = null;
            delete this.store.getState().cmss.projects
            this.store.dispatch({ type: cmsActions.GET_CMS_PROJECTS, payload: { cmsId: this.selectedCMSitem.id } }).catch(() => {
                this.selectedCMSitem = null;
                this.selectedCMSid = null;
            });
        } else {
            this.setCMSToProject();
        }
    } 

    @HostListener('window:resize', ['$event'])
    public onResize() {
        this.showDropUp();
    }

    public getProjectData(){
        return this.projectData;
    }

    setCMSToProject(toRemember=false) {
       // store.getState().cmss.projects
       this.selectedProjectCMSitem = this.store.getState().cmss.projects.find(x => x.name == this.selectedProjectCMS)
        if (toRemember) {
            if (!this.selectedCMSitem) {
                this.selectedCMSitem = {}
                this.selectedCMSitem.id = this.projectData.connectedCmsProject.cmsId;
                this.selectedCMSitem.type = this.projectData.connectedCmsProject.cmsType;
                this.selectedCMSitem.name = this.projectData.connectedCmsProject.cmsTypeName;
                if (!this.selectedProjectCMSitem) {
                    this.selectedProjectCMSitem = {};
                    this.selectedProjectCMSitem.id = this.projectData.connectedCmsProject.id
                    this.selectedProjectCMSitem.name = this.projectData.connectedCmsProject.name;
                }
                this.projectData.options.CMS = true;
                this.insertToJson('options',true,'CMS')
            }
        } else {
            this.projectData.connectedCmsProject = {};
            this.insertToJson('connectedCmsProject',{})
        }

        if (this.selectedCMSitem && this.selectedCMSitem.type == 6) {
          this.projectData.id ? this.insertToJson('connectedCmsProject',this.projectData.id,'id') : this.insertToJson('connectedCmsProject',-1,'id');  
          this.insertToJson('connectedCmsProject',this.projectData.name,'name');  
        } else {
            this.selectedProjectCMSitem ? this.insertToJson('connectedCmsProject',this.selectedProjectCMSitem.id,'id') : this.insertToJson('connectedCmsProject',null,'id') ;
            this.selectedProjectCMSitem ? this.insertToJson('connectedCmsProject',this.selectedProjectCMSitem.name,'name') : this.insertToJson('connectedCmsProject',null,'name');
           

        }
        if(this.selectedCMSitem){
            this.insertToJson('connectedCmsProject',this.selectedCMSitem.id,'cmsId')
            this.insertToJson('connectedCmsProject',this.selectedCMSitem.type,'cmsType')
            this.insertToJson('connectedCmsProject',this.selectedCMSitem.name,'cmsTypeName')
        }
    }

    getAdditionalOption = (id) => {
        this.isAdditionalOptionsCollapsed = false;
        if (id) {
            this.store.dispatch({ type: projectActions.GET_ADDITIONAL_OPTIONS, payload: { dbId: id } }).then(res => {
                if (res.data) {
                    this.insertToJson('additionalOption',res.data)
                }
            });
        }
    }

    getDBTypeFlags = async (dbTypeId) => {
        const dbtFlags = await this.dbTypeService.getFlags(dbTypeId);
        setTimeout(() => { this.dbTypeFlags = dbtFlags; }, 50);
    }

    loadDBTypeSpecific = (dbTypeId) => {
        this.getAdditionalOption(dbTypeId);
        this.getDBTypeFlags(dbTypeId);
    }

    testSourceFolder(){
        if(this.projectData && this.projectData.options &&
            this.projectData.options.DeployOptions.SourceControlFolder &&
            this.projectData.options.DeployOptions.SourceControlFolder !== ''){

        this.store.dispatch({ type: projectActions.TEST_SOURCE_CONTROL_FOLDER, payload: {
            Path: this.projectData.options.DeployOptions.SourceControlFolder
        } }).then(res => {
            if (res.data) {
                this.dialogManagerService.showSuccessDialog({ title: 'Test Folder', text: 'Success' });
            }
        });
        } else {
            this.dialogManagerService.showErrorDialog({
                title: 'Error',
                text: 'Source control folder is empty'
            });
        }
    }

    initDataForCMS() {
        this.store.dispatch({ type: userActions.GET_CURRENT_USER_DETAILS }).then((res) => {
            delete this.store.getState().user.canCMS;
            this.store.dispatch({
                type: userActions.USER_CAN_LINK_CMS_TO_PROJECT,
                payload: { userId: res.data.id, projectId: '0' }
            }).then(() => {
                if (!this.projectData.options.CMS)
                    this.insertToJson('connectedCmsProject',{})
                this.selectedCMSitem = null;
                this.selectedProjectCMSitem = null;
            }, () => {
                delete this.store.getState().user.canCMS;
                this.insertToJson('options',null,'CMS')
                this.insertToJson('connectedCmsProject',{})
                this.selectedCMSitem = null;
                this.selectedProjectCMSitem = null;
                throw this.$translate('ERROR_USER_AUTH');
            })
        });
    }

    
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/projectWizard/settings-ang7/settings.ts